export default "__VITE_ASSET__B_zPhIU2__"